export default __webpack_public_path__ + "static/media/lfp02.42167b06.jpg";